import React from 'react';
import { useSelector } from 'react-redux';
import { Actions } from '../../../store/actions';
import { dispatch } from '../../../utils/utility/store';
import Pagination from '../../components/Pagination';
import ProptechCard from '../../components/ProtechCard';

export default function HomeTab({ tab }) {
  // State
  const { page, size, tbProptechs } = useSelector(state => state.tbProptechs);

  // Set page no. in store on page change in pagination
  const handlePageChange = (v) => {
    dispatch(Actions.TBProptechs.TBSetPage, v)
  }
  
  // Set page no. and size in store on page change in pagination
  const handleRowChange = (v) => {
    dispatch(Actions.TBProptechs.TBSetPageSize, v)
    dispatch(Actions.TBProptechs.TBSetPage, 0)
  }

  return (
    <>
      <div className="no-print proptech-card-wrapper">
        {/* Proptech card */}
        {
          tbProptechs?.rows && tbProptechs?.rows.length ? tbProptechs?.rows.map((proptech) => {
            return (<ProptechCard proptech={proptech} key={proptech?.id} tab={tab} />)
          }) : null
        }
      </div>
      {/* Pagination */}
      <div className='flex justify-between items-center'>
        {tbProptechs?.count ? <span className='text-sm font-normal'>All values in USD</span> : null}
        {tbProptechs?.count ?
          <Pagination
            length={tbProptechs?.count}
            tab="Proptechs"
            page={page}
            size={size}
            handlePageChange={(v) => handlePageChange(v)}
            handleRowChange={(v) => handleRowChange(v)}
          />
          : null}
      </div>
    </>
  )
}
